import { Container } from "@mui/material";
import React from "react";
import useUser from "../../../queries/routes/useUser";
import SplashMap from "../components/splash/SplashMap";
import GenieText from "../../../components/core/genie-text/GenieText";

function All() {
  const { data: user } = useUser();
  const filteredPurchaseOrgs = user?.purchasing_organizations.filter(
    (po) => po.organization.selected_type !== "Buyer"
  );
  return (
    <Container maxWidth="md">
      <GenieText fontSize={"medium"}>Your Stores</GenieText>
      {filteredPurchaseOrgs &&
        filteredPurchaseOrgs.map((organization) => {
          return (
            <SplashMap
              key={organization.id}
              isSelf={
                !!user?.organizations.find(
                  (adminOrg) => organization.organization.id === adminOrg.id
                )
              }
              organization={organization.organization}
            />
          );
        })}
    </Container>
  );
}

export default All;
